import React, { createContext, useContext, useEffect, useState, useCallback } from "react";
import { api } from "@/lib/api";
import { useAuth } from "@/lib/auth";

const WishCtx = createContext(null);

export function WishlistProvider({ children }) {
  const { user } = useAuth();
  const [ids, setIds] = useState([]);

  const refresh = useCallback(async () => {
    if (!user) { setIds([]); return; }
    try { const { data } = await api.get("/me/wishlist"); setIds(data.ids || []); }
    catch { setIds([]); }
  }, [user]);

  useEffect(() => { refresh(); }, [refresh]);

  const has = (id) => ids.includes(id);
  const toggle = async (id) => {
    if (!user) return { needAuth: true };
    if (ids.includes(id)) {
      setIds((x) => x.filter((i) => i !== id));
      try { const { data } = await api.delete(`/me/wishlist/${id}`); setIds(data.ids || []); } catch { refresh(); }
    } else {
      setIds((x) => [...x, id]);
      try { const { data } = await api.post(`/me/wishlist/${id}`); setIds(data.ids || []); } catch { refresh(); }
    }
    return { needAuth: false };
  };

  return <WishCtx.Provider value={{ ids, has, toggle, refresh, count: ids.length }}>{children}</WishCtx.Provider>;
}

export const useWishlist = () => useContext(WishCtx) || { ids: [], has: () => false, toggle: async () => ({ needAuth: true }), refresh: () => {}, count: 0 };
